import type { ThreadSummary } from '../conversations-model'
import styles from '../ConversationsPage.module.css'

function dateLabel(timestamp: number) {
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(timestamp)
}

export function ThreadPicker({
  candidates,
  onSelect,
}: {
  candidates: ThreadSummary[]
  onSelect: (thread: ThreadSummary) => void
}) {
  return (
    <div className={styles.threadPicker}>
      <h3>Choose a recent thread</h3>
      <p>The stored activity does not identify one thread with certainty.</p>
      <ul>
        {candidates.map((thread, index) => (
          <li key={thread.threadId}>
            <button type="button" onClick={() => onSelect(thread)}>
              <strong>
                {thread.channel} thread {index + 1}
              </strong>
              <span>{dateLabel(thread.startTimestamp)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
